
<template>
  <!-- <v-sheet class="bgMinsal" height="50"> -->
    
      <!-- <v-row  >
        
        <v-btn 
          style="margin-top: 40px;"
          plain
          color="black" 
          fab
          absolute 
          right 
          top
          @click="drawer = !drawer">
          <v-icon size="45">mdi-view-headline</v-icon>
        </v-btn>
      
      </v-row> -->
    <v-navigation-drawer
      height="100%"
      v-model="sideBarValue"
      fixed
      temporary
      width="100%"

    >
    <template v-slot:prepend>
      <div elevation="2" class="ma-4 py-0" v-if="!sideBar">
          <v-btn text icon x-large color="white">
            <v-icon size="30">mdi-view-headline-</v-icon>
          </v-btn>
        </div>
        <div v-else class="d-flex justify-end pa-2">
          <v-btn
            text
            icon
            x-large
            color="#313945"
            class="sidebar--close"
            @click="menuExpan = !menuExpan; sideBarValue = false;"
          >
            <v-icon size="30">mdi-close</v-icon>
          </v-btn>
        </div>

      <div class="d-flex flex-column">
        <div
          v-if="
            $vuetify.breakpoint.width > 960 ? !menuExpan : menuExpan || !sideBar
          "
          class="order-0"
        >
          <div class="text-center">
            <img src="@/assets/img/logo_acuerdo.png" width="200" style="filter: grayscale(55%)"/>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <img src="@/assets/img/logo_acuerdo.png" width="200" style="filter: grayscale(55%)"/>
          </div>
        </div>
      </div>

      
    </template>
    <v-list dense nav v-if="menu">
      <span v-for="(item, i) in menu"
            :key="i">

        <v-list-group active-class="white--text" v-if="item.childrens && item.childrens.length">
        <template v-slot:activator>
          <v-list-item-title class="">
            {{ item.titulo }}
          </v-list-item-title>
        </template>
      
          <div>
            <v-list-item v-for="(child, j) in item.childrens" :key="j" :to="child.ruta" active-class="blueGrayMinsal--text">
              <v-list-item-icon>
                <v-icon>{{ child.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="">
                <span>{{ child.titulo }}</span>
              </v-list-item-title>
            </v-list-item>
          </div>
      </v-list-group>
        <v-list-item v-else :to="item.ruta"
                      active-class="blueGrayMinsal--text">
          <v-tooltip right :disabled="!sideBar" >
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon >{{ item.icono }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ item.titulo }}</span>
          </v-tooltip>

        <v-list-item-title class="text-capitalize ">
          {{ item.titulo }}
        </v-list-item-title>
        </v-list-item>
      </span>
    </v-list>

    </v-navigation-drawer>
  <!-- </v-sheet> -->
</template>



<script>
import {mapMutations, mapState} from "vuex";

export default {
name: "AppAsideBarMobil",
props: {
  menu: {
      type: Array,
      default: () => {
        return [];
      },
  },
},
data: () => ({
  
  drawer: null,
  // menu:[],
  nombre:null,
  menuExpan: false,
  apellido:null,
}),
methods: {
  ...mapMutations("utils", ["setSideBar", "setMenu"]),
  ...mapMutations(["setToken","setUserInfo"]),

  async cerrarSession() {
    if(this.isTokenValido(this.token)) {
      this.setMenu([]);
      //this.setToken(null);
      await this.services.auth.logout()
      localStorage.clear();
      this.$router.push({name: 'login'}).catch((e) => {
      });

    } else {
      this.temporalAlert({
        show:true,
        type:"error",
        message:"El token ya expiró, debe de volver a iniciar sesión"
      })
      this.$router.replace({name: "login"})
    }
  },
},
computed: {
  ...mapState(["userInfo", "token"]),
  ...mapState("utils", {
    sideBar: "sideBar",
  }),

  sideBarValue: {
    get() {
      return this.sideBar;
    },
    set(value) {
      this.setSideBar(value);
    }
  }
},
created() {
  let p_n = this.userInfo.nombres.split(" ")
  this.nombre = p_n[0]
  let p_a = this.userInfo.apellidos.split(" ")
  this.apellido = p_a[0]
}
};
</script>

<style scoped>

.margen-abajo{
position: relative;
top: 250px;
}
.sidebar--close {
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.9);
  margin: 4px;
}
</style>